import activity from './locales/js/activity.en.js';
import analytics from './locales/js/analytics.en.js';
import announcement from './locales/js/announcement.en.js';
import building from './locales/js/building.en.js';
import button from './locales/js/button.en.js';
import client from './locales/js/client.en.js';
import company from './locales/js/company.en.js';
import constants from './locales/js/constants.en.js';
import contact from './locales/js/contact.en.js';
import countries from './locales/js/countries.en.js';
import customer from './locales/js/customer.en.js';
import decision from './locales/js/decision.en.js';
import decision_type from './locales/js/decision_type.en.js';
import document from './locales/js/document.en.js';
import dropzone from './locales/js/dropzone.en.js';
import editor_ziggu from './locales/js/editor_ziggu.en.js';
import employee from './locales/js/employee.en.js';
import form from './locales/js/form.en.js';
import inspiration from './locales/js/inspiration.en.js';
import inspiration_list from './locales/js/inspiration_list.en.js';
import installment from './locales/js/installment.en.js';
import installment_term from './locales/js/installment_term.en.js';
import integration from './locales/js/integration.en.js';
import integration_error from './locales/js/integration_error.en.js';
import issue from './locales/js/issue.en.js';
import issue_category from './locales/js/issue_category.en.js';
import issue_list from './locales/js/issue_list.en.js';
import issue_status from './locales/js/issue_status.en.js';
import lead from './locales/js/lead.en.js';
import levels from './locales/js/levels.en.js';
import lot from './locales/js/lot.en.js';
import message from './locales/js/message.en.js';
import milestone from './locales/js/milestone.en.js';
import modal from './locales/js/modal.en.js';
import navbar from './locales/js/navbar.en.js';
import notification from './locales/js/notification.en.js';
import pages from './locales/js/pages.en.js';
import partner from './locales/js/partner.en.js';
import phase from './locales/js/phase.en.js';
import profile from './locales/js/profile.en.js';
import project from './locales/js/project.en.js';
import proposal from './locales/js/proposal.en.js';
import question from './locales/js/question.en.js';
import question_list from './locales/js/question_list.en.js';
import reminder from './locales/js/reminder.en.js';
import sales from './locales/js/sales.en.js';
import select from './locales/js/select.en.js';
import session from './locales/js/session.en.js';
import signature from './locales/js/signature.en.js';
import space from './locales/js/space.en.js';
import subscription from './locales/js/subscription.en.js';
import survey from './locales/js/survey.en.js';
import survey_type from './locales/js/survey_type.en.js';
import tenant from './locales/js/tenant.en.js';
import ticket from './locales/js/ticket.en.js';
import timestamp from './locales/js/timestamp.en.js';
import toast from './locales/js/toast.en.js';
import todo from './locales/js/todo.en.js';
import todo_list from './locales/js/todo_list.en.js';
import unit from './locales/js/unit.en.js';
import upsell from './locales/js/upsell.en.js';
import validation from './locales/js/validation.en.js';
import window from './locales/js/window.en.js';

export default {
  en: {
    ...activity.en,
    ...analytics.en,
    ...announcement.en,
    ...building.en,
    ...button.en,
    ...client.en,
    ...company.en,
    ...constants.en,
    ...contact.en,
    ...countries.en,
    ...customer.en,
    ...decision.en,
    ...decision_type.en,
    ...document.en,
    ...dropzone.en,
    ...editor_ziggu.en,
    ...employee.en,
    ...form.en,
    ...inspiration.en,
    ...inspiration_list.en,
    ...installment.en,
    ...installment_term.en,
    ...integration.en,
    ...integration_error.en,
    ...issue.en,
    ...issue_category.en,
    ...issue_list.en,
    ...issue_status.en,
    ...lead.en,
    ...levels.en,
    ...lot.en,
    ...message.en,
    ...milestone.en,
    ...modal.en,
    ...navbar.en,
    ...notification.en,
    ...pages.en,
    ...partner.en,
    ...phase.en,
    ...profile.en,
    ...project.en,
    ...proposal.en,
    ...question.en,
    ...question_list.en,
    ...reminder.en,
    ...sales.en,
    ...select.en,
    ...session.en,
    ...signature.en,
    ...space.en,
    ...subscription.en,
    ...survey.en,
    ...survey_type.en,
    ...tenant.en,
    ...ticket.en,
    ...timestamp.en,
    ...toast.en,
    ...todo.en,
    ...todo_list.en,
    ...unit.en,
    ...upsell.en,
    ...validation.en,
    ...window.en,
  },
};
